module.exports = __webpack_public_path__ + "img/c.f3ed08ee.png";